export class HoldedToSageError extends Error {
  constructor(
    public fileType: 'asientos' | 'clientes' | 'plan',
    public fileName: string,
    public headerClue: string,
    public originalError?: any,
    public sheetPreview?: any[]
  ) {
    super(`Error converting ${fileType}: ${fileName}`);
    this.name = 'HoldedToSageError';
  }
}
